<template>
	<div class="agreement">
		<home-nav></home-nav>
		<!-- 登入-协议 -->
		<div class="cut_off"></div>
		<div class="agreement_box">
			<!-- 2 -->
			<div>
				<div class="safety_content">
					<div class="content_title">
						<h1>設定結算週期&日期</h1>
						<div class="safety_back"></div>
					</div>
					<p class="set_box mar24">
						<span>請設置您的結算方式：</span>
						<el-radio v-model="radio" label="1">每日結算</el-radio>
						<el-radio v-model="radio" label="2">每週結算</el-radio>
						<el-radio v-model="radio" label="3">每月結算</el-radio>
					</p>
					<div class="radioshow">
						<!-- radio:1 -->
						<div class="radio_1 mar24" v-show="radio == '1'">
						</div>
						<!-- radio:2 -->
							<div  class="radio_2 mar24" v-show="radio == '2'">
								<span>
									請設置您每週可提現時間(最多2天)：
									<span class="red_span" v-for="(item, index) in weeklyVal" :key="index">
										{{item}}
									</span>
								</span>
								<div class="weekly_box">
									<el-checkbox-group v-model="weeklyVal" :max="2">
										<el-checkbox-button v-for="weekly in weeklyList" :label="weekly" :key="weekly">
											{{weekly}}
										</el-checkbox-button>
									</el-checkbox-group>
								</div>
							</div>

						<!-- radio:3 -->
							<div  class="radio_2 mar24" v-show="radio == '3'">
								<span>
									請設置您每月可提現時間(最多2天)：
									<span class="red_span" v-for="(item, index) in monthVal" :key="index">
										{{item}}日
									</span>
								</span>
								<div class="month_box">
									<p :class="monthTFFun(item.valTF)" @click="monthFun(index)" v-for="(item, index) in monthList" :key="item.val">
										{{item.val}}
									</p>
								</div>
							</div>
							<!-- 按鈕 — box -->
							<div class="button_box">
								<el-button type="primary" @click="goLogin()">保存</el-button>
							</div>
					</div>
				</div>
			</div>
			<!-- agreement_box -->
		</div>
		<login-footer></login-footer>
	</div>
</template>

<script>
	import HomeNav from './Nav.vue';
	import loginFooter from './Footer.vue';
	import axios from 'axios';

	export default {
		name: 'SetWithdraw',
		props: {},
		data() {
			return {
				radio: '1',
				weeklyList:[
					'星期日',
					'星期一',
					'星期二',
					'星期三',
					'星期四',
					'星期五',
					'星期六',
				],
				weeklyVal: [],
				monthList:[
					{
						val: '1',
						valTF: '0',
					},
					{
						val: '2',
						valTF: '0',
					},
					{
						val: '3',
						valTF: '0',
					},
					{
						val: '4',
						valTF: '0',
					},
					{
						val: '5',
						valTF: '0',
					},
					{
						val: '6',
						valTF: '0',
					},
					{
						val: '7',
						valTF: '0',
					},
					{
						val: '8',
						valTF: '0',
					},
					{
						val: '9',
						valTF: '0',
					},
					{
						val: '10',
						valTF: '0',
					},
					{
						val: '11',
						valTF: '0',
					},
					{
						val: '12',
						valTF: '0',
					},
					{
						val: '13',
						valTF: '0',
					},
					{
						val: '14',
						valTF: '0',
					},
					{
						val: '15',
						valTF: '0',
					},
					{
						val: '16',
						valTF: '0',
					},
					{
						val: '17',
						valTF: '0',
					},
					{
						val: '18',
						valTF: '0',
					},
					{
						val: '19',
						valTF: '0',
					},
					{
						val: '20',
						valTF: '0',
					},
					{
						val: '21',
						valTF: '0',
					},
					{
						val: '22',
						valTF: '0',
					},
					{
						val: '23',
						valTF: '0',
					},
					{
						val: '24',
						valTF: '0',
					},
					{
						val: '25',
						valTF: '0',
					},
					{
						val: '26',
						valTF: '0',
					},
					{
						val: '27',
						valTF: '0',
					},
					{
						val: '28',
						valTF: '0',
					},
				],
				monthNumber: 0,
			}
		},
		components: {
			HomeNav,
			loginFooter
		},
		computed: {
			// 月選擇：
			monthVal(){
				let list = [];
				for (let key in this.monthList) {
					if(this.monthList[key].valTF == '1'){
						list.push(this.monthList[key].val);
					}
				}
				return list;
			}
		},
		methods: {
			// 周判斷：
			weeklyValFun(){
				let list = [];
				for(let i=0; i<this.weeklyVal.length; i++){
					// console.log(this.weeklyVal[i]);
					if(this.weeklyVal[i] == '星期日'){
						list.push('0');
					} else if (this.weeklyVal[i] == '星期一'){
						list.push('1');
					} else if (this.weeklyVal[i] == '星期二'){
						list.push('2');
					} else if (this.weeklyVal[i] == '星期三'){
						list.push('3');
					} else if (this.weeklyVal[i] == '星期四'){
						list.push('4');
					} else if (this.weeklyVal[i] == '星期五'){
						list.push('5');
					} else {
						list.push('6');
					}
				}
				return list;
			},
			// 點擊是否：
			monthFun(index){
				let val = this.monthList[index].valTF;
				if(this.monthNumber <2){
					if(val == '1'){
						this.monthList[index].valTF = '0';
						this.monthNumber -= 1; 
					} else {
						this.monthList[index].valTF = '1';
						this.monthNumber += 1; 
					}
				} else {
					if(val == '1'){
						this.monthList[index].valTF = '0';
						this.monthNumber -= 1;
					}
				}

			},
			// Class:
			monthTFFun(val){
				if(val == '0'){
					return ['']
				} else {
					return ['active']
				}
			},
			goLogin() {
				// this.$router.push("/login");
				let dwmVal = '';
				// 判断 日-周-月：
				if(this.radio == '1'){
					dwmVal = ['0'];
				} else if(this.radio == '2'){
					dwmVal = this.weeklyValFun();
				} else {
					dwmVal = this.monthVal;
				}
				// axios:
				axios.get(this.$store.state.axiossetwithdrawForm, {
					params:{
						uid: this.$store.state.uid,
						settled_status: this.radio,
						settled_date: dwmVal,
					}
				}).then(res =>{
					if(res.data.status){
						this.$router.push("/login");
					}
				})
			},
		},
		created(){

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 分割线 */
 .list_bock .z_index{
	  position: absolute;
    left: 24%;
    top: 11%;
    margin-left:0px;
    width: 800px;
    overflow: hidden;
    z-index: 10;
    border: 1px solid #5c595e;
		background-color: #ffffff;
 }
	.cut_off {
		height: 4px;
		background: #e73262;
	}

	.agreement_content {
		box-sizing: border-box;
		width: 768px;
		border: 2px solid #bbbbbb;
		margin: 0 auto;
		margin-top: 45px;
		margin-bottom: 45px;
		padding: 37px 46px;
		padding-bottom: 0px;
		color: #777777;
		overflow: hidden;
	}

	.agreement_content>p {
		margin: 29px 40px;
		line-height: 42px;
	}

	.content_title {
		box-sizing: border-box;
		font-size: 21px;
		font-weight: bold;
		position: relative;
		margin-left: 40px;
	}

	.agreement_checkbox {
		margin-left: 40px;
	}

	.title_back {
		width: 90px;
		height: 25px;
		background: #f2f2f2;
		position: absolute;
		top: 5px;
		z-index: -1;
	}

	.safety_back {
		width: 200px;
		height: 25px;
		background: #f2f2f2;
		position: absolute;
		top: 5px;
		z-index: -1;
	}

	.agreement_checked {
		color: #e73262;
		padding-bottom: 4px;
		border-bottom: 1px solid;
	}

	.button_box {
		box-sizing: border-box;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 30px 0;
	}


	/* 2 */
	.red_span {
		color: #e73262;
	}
	.red_span+.red_span {
		margin-left: 4px;
	}
	.weekly_box {
		margin-top: 24px;
	}
	.safety_content {
		box-sizing: border-box;
		width: 768px;
		border: 2px solid #bbbbbb;
		margin: 0 auto;
		margin-top: 45px;
		margin-bottom: 45px;
		padding: 37px 46px;
		padding-bottom: 0px;
		color: #777777;
		overflow: hidden;
		font-size: 13px;
	}

	.safety_box>div {
		margin: 13px 40px;
	}

	.safety_box .information,
	.safety_box .pass {
		width: 300px;
	}

	.googole {
		color: #9db3f0;
		margin-left: 40px;
		margin-top: 20px;
		margin-bottom: 40px;
	}

	.googole>p {
		cursor: pointer;
		padding-bottom: 4px;
		width: 250px;
		border-bottom: 1px solid;
	}

	.safety_button {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 300px;
		margin: 0 auto;
		margin-bottom: 30px;
	}
	/* 3 */
	.month_box {
		width: 583px;
		margin-top: 20px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #cccccc;
	}
	.month_box .active {
		background: #e73262;
		color: white;
	}
	.month_box > p {
		font-size: 20px;
		width: 83px;
		height: 40px;
		box-sizing: border-box;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #cccccc;
	}
	/* set-CSS */
	.mar24 {
		margin: 30px 40px;
	}
	.radio_1 {
		height: 40px;
	}
	.radioshow {
		min-height: 200px;
	}
	.set_box >span {
		margin-right: 20px;
	}
	.radio_2 >span {
		margin-right: 10px;
	}
	.button_box button {
		width: 140px;
	}
</style>
